import {CircularProgress} from '@mui/material';
import {useTranslation} from 'react-i18next';
import {
  BodyText,
  CustomSpacingDivComponent,
  FullScreenLoaderComponent,
  LoaderContent
} from './FullScreenStyle';

export interface FullScreenLoaderProps {
  size?: number;
  animationDuration?: string;
  color?: string;
  loaderText?: string;
  doNotPressText?: boolean;
}

export default function FullScreenLoader(
  props: FullScreenLoaderProps
): JSX.Element {
  const {t} = useTranslation();
  const {
    size = 80,
    animationDuration = '900ms',
    loaderText,
    doNotPressText
  } = props;

  return (
    <FullScreenLoaderComponent>
      <LoaderContent>
        <CustomSpacingDivComponent>
          <CircularProgress
            style={{animationDuration: animationDuration}}
            size={size}
            color="primary"
          />
        </CustomSpacingDivComponent>
        {loaderText ? (
          <BodyText>
            {t('APP.COMPONENTS.LOADERS.FS_LOADER_SUBMITTING')}
          </BodyText>
        ) : (
          ''
        )}
        {doNotPressText && (
          <BodyText>{t('APP.COMPONENTS.LOADERS.FS_LOADER_DNP')}</BodyText>
        )}
      </LoaderContent>
    </FullScreenLoaderComponent>
  );
}
